// src/context/SnackbarUtils.js
let snackbarHandler;

export const setSnackbarHandler = (handler) => {
  snackbarHandler = handler;
};

export const showGlobalSnackbar = (msg, severity = "error") => {
  if (snackbarHandler) {
    snackbarHandler(msg, severity);
  }
};
